import { render, staticRenderFns } from "./hotSaleCourse.vue?vue&type=template&id=41d80caf&scoped=true&"
import script from "./hotSaleCourse.vue?vue&type=script&lang=js&"
export * from "./hotSaleCourse.vue?vue&type=script&lang=js&"
import style0 from "./hotSaleCourse.vue?vue&type=style&index=0&id=41d80caf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d80caf",
  null
  
)

export default component.exports